// extracted by mini-css-extract-plugin
export default {"container":"new_booking_link_container__f1Tss"};